export type Role = 'super_admin' | 'admin' | 'viewer';

export const canMutate = (role: string | undefined) => role === 'super_admin' || role === 'admin';

export const roleLabel = (role: string | undefined) => (role ?? 'viewer').replace('_', ' ');
